import * as types from '../actionTypes/annualReturnClient'

export function getClientsForAnnualReturn(annualReturnClients) {
  return{
      type: types.GET_CLIENTS_FOR_ANNUAL_RETURN,
      annualReturnClients
  }
}

export function getAnnualReturnClient(annualReturnClient) {
  return{
      type: types.GET_ANNUAL_RETURN_CLIENT,
      annualReturnClient
  }
}

export function updateClientForAnnualReturn(annualReturnClient) {
  return{
      type: types.UPDATE_CLIENT_FOR_ANNUAL_RETURN,
      annualReturnClient
  }
}

export function addClientToAnnualReturn(annualReturnClient) {
  return{
      type: types.ADD_CLIENT_TO_ANNUAL_RETURN,
      annualReturnClient
  }
}

export function clearAnnualReturnClient() {
  return{
      type: types.CLEAR_ANNUAL_RETURN_CLIENT
  }
}
export function getEmployeesForAnnualReturn(annualReturnEmployees) {
  return{
      type: types.GET_EMPLOYEES_FOR_ANNUAL_RETURN,
      annualReturnEmployees
  }
}




// WEBPACK FOOTER //
// ./src/actions/annualReturnClient.js